var render = function render(){var _vm=this,_c=_vm._self._c;return _c('config-item',{attrs:{"label":_vm.label}},[_c('div',{staticStyle:{"display":"flex","justify-content":"flex-end","font-size":"14px","margin-top":"10px"}},[_vm._v(" "+_vm._s(_vm.loginType))])])
}
var staticRenderFns = []

export { render, staticRenderFns }